<template>
  <div id="calculator">
    <v-row class="mx-0 my-5 pt-10">
      <v-col style="text-align:center">
        <span class="ct-text-subtitle sectTitle2">{{ title }}</span>
      </v-col>
    </v-row>
    <treeSize
      v-if="!calculated"
      :treeCo2List="treeCo2List"
      @calculateTree="calculateTree"
    />
    <treeCarbon
      v-if="calculated"
      :tree-co2-list="treeCo2List"
      :tree-data="treeData"
      :base-carbon="baseCarbon"
      :recheck-carbon="recheckCarbon"
      :display-carbon="displayCarbon"
      :display-title="displayTitle"
      :has-recheck="hasRecheck"
      @calculateAnother="calculateAnother"
    />
  </div>
</template>

<script>
import treeSize from "@/components/carbon/treeSize.vue";
import treeCarbon from "@/components/carbon/treeCarbon.vue";
export default {
  props: {
    title: {
      type: String
    }
  },
  data() {
    return {
      calculated: false,
      baseCarbon: "0.0",
      recheckCarbon: "",
      displayCarbon: "0.0",
      displayTitle: "樹木固碳量",
      hasRecheck: false,
      treeCo2List: [],
      treeData: null
    };
  },
  components: {
    treeSize,
    treeCarbon
  },
  mounted() {
    this.getCo2List();
  },
  methods: {
    isFilled(value) {
      return (
        value !== null && value !== undefined && String(value).trim() !== ""
      );
    },
    formatCarbon(value) {
      if (!Number.isFinite(value)) {
        return "0.0";
      }
      return value.toFixed(1).toString();
    },
    getCo2List() {
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Carbon/GetTreeCo2List`
      }).then(res => {
        this.treeCo2List = res.data.data;
      });
    },
    calculateCarbonValue(model, measureData) {
      let carbon = 0;

      if (model.isAdvance) {
        const tree = this.treeCo2List.find(x => +x.Sno === +model.type);
        if (!tree) {
          return carbon;
        }

        if (+tree.Co2Type === 3) {
          const lnDBH = Math.log(+measureData.diameter);
          const lnH = Math.log(+measureData.height);

          const lnC = -3.64 + 1.84 * lnDBH + 0.88 * lnH;
          carbon = Math.pow(Math.E, lnC) * (44 / 12);
        } else {
          carbon =
            Math.round(
              0.45 *
                ((+measureData.diameter / 100) * 0.5) ** 2 *
                Math.PI *
                +measureData.height *
                tree.Density *
                1.4 *
                (1 + 0.24) *
                (tree.Carbon / 100) *
                (44 / 12) *
                1000 *
                100
            ) / 100;
        }
      } else {
        let lnDBH = 0;
        let lnH = 0;
        let lnC = 0;
        switch (+model.type) {
          case 1:
            carbon =
              Math.round(
                0.45 *
                  ((+measureData.diameter / 100) * 0.5) ** 2 *
                  Math.PI *
                  +measureData.height *
                  1.68 *
                  1000 *
                  100
              ) / 100;
            break;
          case 2:
            carbon =
              Math.round(
                0.45 *
                  ((+measureData.diameter / 100) * 0.5) ** 2 *
                  Math.PI *
                  +measureData.height *
                  1.12 *
                  1000 *
                  100
              ) / 100;
            break;
          case 3:
            lnDBH = Math.log(+measureData.diameter);
            lnH = Math.log(+measureData.height);

            lnC = -3.64 + 1.84 * lnDBH + 0.88 * lnH;
            carbon = Math.pow(Math.E, lnC) * (44 / 12);
            break;
        }
      }

      return carbon;
    },
    calculateTree(treeData) {
      this.treeData = treeData;

      const model = {
        isAdvance: treeData.isAdvance,
        type: treeData.type
      };

      const baseCarbonValue = this.calculateCarbonValue(model, treeData.base);
      const hasRecheck = ["height", "diameter", "perimeter"].every(key =>
        this.isFilled(treeData.recheck[key])
      );

      let recheckCarbonValue = null;
      let displayCarbonValue = baseCarbonValue;
      let displayTitle = "樹木固碳量";

      if (hasRecheck) {
        recheckCarbonValue = this.calculateCarbonValue(model, treeData.recheck);
        displayCarbonValue = recheckCarbonValue - baseCarbonValue;
        displayTitle = "樹木碳匯量";
      }

      this.baseCarbon = this.formatCarbon(baseCarbonValue);
      this.recheckCarbon = hasRecheck
        ? this.formatCarbon(recheckCarbonValue)
        : "";
      this.displayCarbon = this.formatCarbon(displayCarbonValue);
      this.displayTitle = displayTitle;
      this.hasRecheck = hasRecheck;
      this.calculated = true;
    },
    calculateAnother() {
      this.calculated = false;
    }
  }
};
</script>

<style lang="scss" scoped>
#calculator {
  background-repeat: repeat;
  background-position: 50% 50%;
  background-image: url("~@/assets/images/announce/bg_title.png");
  height: auto;
}

.shadow-btn {
  box-shadow: none;
}
</style>
